import { render, staticRenderFns } from "./post-card.vue?vue&type=template&id=7d5a52ed&scoped=true&"
import script from "./post-card.vue?vue&type=script&lang=js&"
export * from "./post-card.vue?vue&type=script&lang=js&"
import style0 from "./post-card.vue?vue&type=style&index=0&id=7d5a52ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5a52ed",
  null
  
)

export default component.exports